<template>
  <div>
    <div>
      <img
        class="mainBackImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/newsInformation/backgroundImg.jpg')
            : require('@/assets/images/newsInformation/en_backgroundImg.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="20" :lg="18" :xl="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>

    <div class="container">
      <!-- 新闻动态 -->
      <div class="companyBox">
        <div class="searchW">
          <div class="searchTitleBox">
            <div class="searchTitletext">
              {{ typeData[$route.query.id].name }}
            </div>
            <div class="searchBoxRight">
              <div class="searchRow">
                <div class="searchRowLable">{{ $t("news.year") }}:</div>
                <el-select
                  class="searchSelect"
                  v-model="search.push_year"
                  clearable
                  :placeholder="$t('news.selectYear')"
                  @change="searchClick"
                >
                  <el-option
                    v-for="(item, inedx) in yearData"
                    :key="inedx"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="searchInputBox">
                <el-input
                  class="searchInput"
                  :placeholder="$t('home.searchTips')"
                  v-model="search.keywords"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button
                  class="searchBtn"
                  style="background-color: #32589f; color: #ffffff"
                  round
                  @click="searchClick"
                  >{{ $t("home.searchBtn") }}</el-button
                >
              </div>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
        <!--  -->
        <industryTrends
          ref="industryTrends"
          :type="typeData[$route.query.id].id"
          :search="search"
          @change="setSearch"
        ></industryTrends>
        <!-- 分页 -->
        <div class="paginationBox" v-if="totalPages > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="search.page"
            :page-size.sync="search.size"
            :total.sync="totalPages"
            @current-change="currentPageChange"
          ></el-pagination>
        </div>
        <!--  -->
      </div>
    </div>
  </div>
</template>

<script>
import industryTrends from "@/views/newsInformation/newsItem/industryTrends";
import { parseTime, routeName } from "@/utils";
import { localStorage } from "../../utils/storage";

export default {
  name: "news_list",
  components: { industryTrends },
  data() {
    return {
      language: localStorage.get("language") || "zh",
      typeData: {
        3000: { tyep: 3000, name: this.$t("news.companyNews"), id: 4 },
        3001: { tyep: 3001, name: this.$t("news.industryNews"), id: 2 },
        3014: {
          tyep: 3014,
          name: this.$t("news.informationDisclosure"),
          id: 5,
        },
      },
      yearData: [],
      totalPages: 0,
      search: {
        push_year: "",
        keywords: "",
        page: 1,
        size: 10,
      },
    };
  },
  created() {
    this.yearData = [];
    for (let index = 0; index < 5; index++) {
      const getData = new Date().getFullYear() - index;
      const setData = new Date().setFullYear(getData);
      this.yearData.push(parseTime(setData, "{y}"));
    }
  },
  mounted() {
    this.resetScrollTop();
  },

  methods: {
    resetScrollTop() {
      this.$nextTick(() => {
        document.getElementById("pageMain").scrollTop = 0;
      });
    },
    // 搜索
    searchClick() {
      this.search.page = 1;
      this.getSearch();
    },
    getSearch() {
      this.$refs["industryTrends"].getDynamicData();
    },
    setSearch(data) {
      this.search.page = data.currentPage; //当前页数
      this.totalPages = data.count; //总页数
    },
    // 分页
    currentPageChange(e) {
      this.search.page = e;
      this.getSearch();
    },
  },
};
</script>
<style>
.searchInput .el-input__inner {
  border-radius: 80px;
  padding-left: 40px;
}
.searchInput .el-input__prefix {
  left: 10px;
}
</style>
<style scoped>
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.mainBackImg {
  width: 100%;
  /* height: 300px; */
}
.companyBox {
  width: 100%;
  background: #ffffff;
  padding: 20px 0 30px;
}
/* 标题搜索 */
.searchSelect {
  width: 150px;
}
.searchW {
  width: 75%;
  margin: 0 auto;
}
.searchTitleBox {
  /* width: 75%; */
  box-sizing: border-box;
  /* padding: 20px 10px; */
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.searchTitletext {
  font-size: 28px;
  font-weight: bold;
  color: #015a9c;
}
.searchBoxRight {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.searchRow {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.searchRowLable {
  width: 50px;
  padding-right: 10px;
  text-align: right;
  font-size: 15px;
  color: #787b8a;
}
.searchRow /deep/ .el-input__inner {
  border-radius: 80px;
  width: 150px;
}
.searchInputBox {
  display: flex;
  align-items: center;
}
.searchInput {
  width: 200px;
  border-radius: 80px;
  margin-right: 20px;
}
.searchBtn {
  padding: 10px 30px;
  font-size: 15px;
}

/*  */

.companyTitleBox {
  width: 100%;
  padding: 20px 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.companyTitleBox .indexTitle_more {
  position: absolute;
  top: 50%;
  right: 0;
  transform: rotateY(-50%);
}
.titleBottomLine {
  width: 80px;
  height: 10px;
  background: #015a9c;
  border-radius: 10px;
  margin-top: 10px;
}
/* 公司概况 */
.companyListBox {
  width: 100%;
}
.companyList {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  margin: 20px 0;
  box-shadow: 0 0 10px #dcdfe6;
  cursor: pointer;
}
.companyListImgBox {
  width: 100%;
  height: 200px;
}
.companyImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.companyContentBox {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 15px;
}
.companyListDate {
  width: 100%;
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
}
.dateDay {
  font-size: 20px;
  color: #787b8a;
  margin-right: 10px;
}
.dateYear {
  font-size: 16px;
  color: #787b8a;
}
.companyListTitle {
  width: 100%;
  margin: 0 0 20px;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  line-height: 1.6;
  display: -webkit-box;
  overflow: hidden;
  /*! autoprefixer: off; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.companyListContent {
  width: 100%;
  font-size: 14px;
  color: #333333;
  line-height: 1.7;
  display: -webkit-box;
  overflow: hidden;
  /*! autoprefixer: off; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.PartnersBox {
  width: 100%;
  background: #ffffff;
  padding: 20px 0 40px;
}
.partnersImg {
  width: 100%;
  height: auto;
  margin: 5px 0;
  cursor: pointer;
}
/* 分页 */
.paginationBox {
  width: 100%;
  box-sizing: border-box;
  padding: 40px 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 响应式样式 */
@media only screen and (max-width: 768px) {
  /* 标题搜索 */
  .searchW {
    width: 90%;
  }
  .searchTitleBox {
    /* width: 90%; */
    box-sizing: border-box;
    padding: 0 10px 10px;
    display: block;
  }
  .searchBoxRight {
    display: block;
    margin-top: 20px;
  }
  .searchRow {
    margin-bottom: 10px;
  }
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  /* 标题搜索 */
  .searchW {
    width: 90%;
  }
  .searchTitleBox {
    /* width: 90%; */
    box-sizing: border-box;
    padding: 0 10px 10px;
    display: block;
  }
  .searchBoxRight {
    margin-top: 20px;
  }
}

@media screen and (min-width: 992px) {
}

@media screen and (min-width: 1200px) {
}

@media screen and (min-width: 1400px) {
}

@media screen and (min-width: 1920px) {
}
</style>